import { jsx as l } from "react/jsx-runtime";
import { $ as o } from "./utils-CTvPli9r.js";
import { forwardRef as s } from "react";
const r = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ l("table", { ref: t, className: o("w-full caption-bottom text-sm", e), ...a }) })
);
r.displayName = "Table";
const d = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l("thead", { ref: t, className: o("[&_tr]:border-b", e), ...a })
);
d.displayName = "TableHeader";
const m = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l("tbody", { ref: t, className: o("[&_tr:last-child]:border-0", e), ...a })
);
m.displayName = "TableBody";
const b = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l(
    "tfoot",
    {
      ref: t,
      className: o("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", e),
      ...a
    }
  )
);
b.displayName = "TableFooter";
const c = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l(
    "tr",
    {
      ref: t,
      className: o("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", e),
      ...a
    }
  )
);
c.displayName = "TableRow";
const i = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l(
    "th",
    {
      ref: t,
      className: o(
        "h-10 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        e
      ),
      ...a
    }
  )
);
i.displayName = "TableHead";
const n = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l(
    "td",
    {
      ref: t,
      className: o(
        "p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        e
      ),
      ...a
    }
  )
);
n.displayName = "TableCell";
const p = s(
  ({ className: e, ...a }, t) => /* @__PURE__ */ l("caption", { ref: t, className: o("mt-4 text-sm text-muted-foreground", e), ...a })
);
p.displayName = "TableCaption";
export {
  r as Table,
  m as TableBody,
  p as TableCaption,
  n as TableCell,
  b as TableFooter,
  i as TableHead,
  d as TableHeader,
  c as TableRow
};
//# sourceMappingURL=table.js.map
